import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Avatar, AvatarFallback, AvatarImage } from "@shared/ui/avatar";
import { Badge } from "@shared/ui/badge";
import { Card } from "@shared/ui/card";
import {
  Calendar,
  Eye,
  Hash,
  Mail,
  MapPin,
  Phone,
  Shield,
  Smartphone,
  User,
  Briefcase,
  Key,
} from "lucide-react";
import MaskedSSN from "@features/cx/shared/components/MaskedSSN";

export const InfoCard = ({data}: {data: any}) => {
  const appStatus=data?.isUserAccess==true?"Enabled":"Disabled";
  const badgeColor=appStatus=="Enabled"?"bg-green-50 text-green-700 border-green-200":"bg-red-50 text-red-700 border-red-200";
  const status=data?.isActive==true?"Active":"Inactive";
  const statusBadgeColor=status=="Active"?"bg-green-50 text-green-700 border-green-200":"bg-red-50 text-red-700 border-red-200";
  const infoItems = [
{
  label: "EMAIL",
  value: (
    <span
      className="block max-w-[200px] truncate"
      title={data?.email}
    >
      {data?.email}
    </span>
  )
},  
    {
      label: "PHONE",
      value: data?.contactNumber || "N/A",
    
    },
    {
      label: "ADDRESS",
      value: data?.address || "N/A",
     
    },
    {
      label: "DEPARTMENT",
      value: data?.extraDataMap?.department?.join(", ") || "N/A",
     
    },
    {
      label: "APP VERSION",
      value: data?.version || "N/A",
     
    },
    {
      label: "JOINING DATE",
      value: data?.joiningDate || "N/A",
     
    },
    {
      label: "IMEI NUMBER",
      value: data?.imeiNo || "N/A",
   
    },
    {
      label: "APP ACCOUNT",
      value: (
        <Badge
          variant="outline"
          className={badgeColor}
        >
          {appStatus}
        </Badge>
      ),
     
    },
    {
      label: "PASSWORD",
      value: <div className="text-sm font-medium"><MaskedSSN ssn={data?.password} /></div>,
    
    },
    {
      label: "CREATED BY",
      value: "N/A",
    
    },
    {
      label: "CREATED ON",
      value: data?.createdDate || "N/A",
   
    },
  ];

  const initials = data?.name
    ?.split(" ")
    .map((n: any) => n[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

  return (
    <Card className="p-6">
      <div className="flex justify-between items-start mb-8">
        <div className="flex gap-4">
          <Avatar className="h-16 w-16 rounded-xl bg-blue-50 text-blue-600 border border-blue-100">
            <AvatarImage src={data?.file} className="object-cover" />
            <AvatarFallback className="rounded-xl bg-blue-50 text-blue-600 text-xl font-medium">
              {initials}
            </AvatarFallback>
          </Avatar>
          <div>
            <div className="flex items-center gap-2 mb-1">
              <h2 className="text-xl font-bold text-gray-900">{data?.name}</h2>
              <Badge
                variant="outline"
                className={statusBadgeColor}
              >
                {status}
              </Badge>
            </div>
            <p className="text-gray-500">{data?.userTypeDisplay}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-500 font-medium mb-1">
            Assigned Routes
          </p>
          <p className="text-2xl font-bold text-blue-600">{data?.routeCount}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-4">
        {infoItems.map((item, index) => (
          <ValueLabel
            key={index}
            label={item.label}
            value={item.value}
          />
        ))}
      </div>
    </Card>
  );
};
